import {
    HiHome,
    HiShoppingBag,
    HiTruck,
    HiUsers,
    HiUserGroup,
    HiShieldCheck,
    HiDocumentText,
    HiCog,
    HiCreditCard,
    HiOfficeBuilding,
    HiCurrencyDollar,
    HiTicket,
    HiTag,
    HiGlobeAlt,
    HiLocationMarker,
    HiScale,
    HiExclamation,
    HiQuestionMarkCircle,
    HiCollection,
    HiRefresh,
    HiReceiptTax
} from 'react-icons/hi';

export const menuData = [
    {
        id: 1,
        title: "menu.main",
        listItems: [
            {
                id: 1,
                title: "menu.homepage",
                url: "/",
                icon: HiHome
            },
            {
                id: 2,
                title: "menu.buy4meOrders",
                url: "/order/index",
                icon: HiShoppingBag
            },
            {
                id: 3,
                title: "menu.ship4meOrders",
                url: "/shipforme",
                icon: HiTruck
            },
            {
                id: 4,
                title: "menu.buyForMeGroups",
                url: "/buyforme-groups",
                icon: HiCollection
            },
            {
                id: 40,
                title: "menu.shipForMeGroups",
                url: "/shipforme-groups",
                icon: HiCollection
            },
            {
                id: 5,
                title: "menu.customers",
                url: "/customers",
                icon: HiUsers
            },
            {
                id: 6,
                title: "menu.users",
                url: "/users",
                icon: HiUserGroup
            },
            {
                id: 7,
                title: "menu.userRoles",
                url: "/roles",
                icon: HiShieldCheck
            },
            {
                id: 8,
                title: "menu.invoices",
                url: "/invoices",
                icon: HiDocumentText
            },
            {
                id: 9,
                title: "menu.contactRequests",
                url: "/contact-requests",
                icon: HiQuestionMarkCircle
            }
        ]
    },
    {
        id: 2,
        title: "menu.settings",
        listItems: [
            {
                id: 1,
                title: "menu.settings",
                url: "/config",
                icon: HiCog
            },
            {
                id: 2,
                title: "menu.paymentMethods",
                url: "/payment-methods",
                icon: HiCreditCard
            },
            {
                id: 3,
                title: "menu.paymentGateways",
                url: "/payment-gateways",
                icon: HiCreditCard
            },
            {
                id: 4,
                title: "menu.shippingCompanies",
                url: "/shipping-companies",
                icon: HiOfficeBuilding
            },
            {
                id: 5,
                title: "menu.currencies",
                url: "/currencies",
                icon: HiCurrencyDollar
            },
            {
                id: 6,
                title: "menu.coupons",
                url: "/vouchers",
                icon: HiTicket
            },
            {
                id: 7,
                title: "menu.categories",
                url: "/categories",
                icon: HiTag
            },
            {
                id: 8,
                title: "menu.countries",
                url: "/countries",
                icon: HiGlobeAlt
            },
            {
                id: 9,
                title: "menu.cities",
                url: "/cities",
                icon: HiLocationMarker
            },
            {
                id: 10,
                title: "menu.measurementUnits",
                url: "/measurement-units",
                icon: HiScale
            },
            {
                id: 11,
                title: "menu.faq",
                url: "/faqs",
                icon: HiQuestionMarkCircle
            },
            {
                id: 12,
                title: "menu.faqCategories",
                url: "/faq-categories",
                icon: HiCollection
            },
            {
                id: 13,
                title: "menu.recovery",
                url: "/recovery",
                icon: HiRefresh
            },
            {
                id: 14,
                title: "menu.recaptchaSettings",
                url: "/settings/recaptcha",
                icon: HiShieldCheck
            },
            {
                id: 15,
                title: "menu.taxProfiles",
                url: "/tax-profiles",
                icon: HiReceiptTax
            }
        ]
    },
    {
        id: 3,
        title: "menu.cms",
        listItems: [
            {
                id: 1,
                title: "menu.sliders",
                url: "/cms/sliders",
                icon: HiCollection
            },
            {
                id: 2,
                title: "menu.generalInfo",
                url: "/cms/general-info",
                icon: HiDocumentText
            }
        ]
    }
];
